'use client'

import dynamic from 'next/dynamic'
import type { EntityData } from '../normalize'

const VirtualTourViewer = dynamic(
  () => import('@/components/virtual-tour/VirtualTourViewer').then(m => m.VirtualTourViewer),
  { ssr: false, loading: () => <div className="ed-vt-loading">Loading virtual tour…</div> },
)

export function VirtualTour({ data, label, explorePrefix, sceneWord, scenesWord }: {
  data: EntityData
  label?: string
  explorePrefix?: string
  sceneWord?: string
  scenesWord?: string
}) {
  const tour = data.virtualTour
  if (!tour || tour.scenes.length === 0) return null

  const vtLabel = label ?? 'VIRTUAL TOUR'
  const prefix  = explorePrefix ?? 'Explore'
  const sw      = sceneWord ?? 'scene'
  const sws     = scenesWord ?? 'scenes'

  return (
    <section className="ed-section ed-vt-section" id="virtual-tour">
      <div className="ed-section-inner">
        <div className="ed-section-label">{vtLabel}</div>
        <div className="ed-vt-header">
          <h2 className="ed-vt-title">{prefix} {data.title}</h2>
          <span className="ed-vt-scene-count">{tour.scenes.length} {tour.scenes.length === 1 ? sw : sws}</span>
        </div>

        <div className="ed-vt-stage">
          <VirtualTourViewer scenes={tour.scenes} startScene={tour.startScene} />
        </div>
      </div>
    </section>
  )
}
